import {get} from './calls';
import config from '../config/config';

export default {
  getUserProfile: () => get(`${config.BFF_BASE_URL}/api/user/profile`)
};
